import React from 'react';
import { CheckIcon } from '@radix-ui/react-icons';
import { PASSWORD_REQUIREMENTS } from '../../utils/passwordValidation';
import './Auth.scss';

interface PasswordRequirementsProps {
  password: string;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => {
  return (
    <div className="auth-requirements" role="region" aria-label="Password requirements">
      <ul className="auth-requirements-list">
        {PASSWORD_REQUIREMENTS.map((requirement) => {
          const met = requirement.test(password);
          return (
            <li
              key={requirement.id}
              className={`auth-requirements-item${met ? ' auth-requirements-item--met' : ''}`}
            >
              <span className="auth-requirements-check" aria-hidden="true">
                {met && <CheckIcon />}
              </span>
              {requirement.label}
            </li>
          );
        })}
      </ul>
      <p className="auth-requirements-note">
        To ensure your data remains secure and well-protected, we require you to create a strong password.
      </p>
    </div>
  );
};
